/** @generated */
// cspell:disable

/** @typedef {import('axios').AxiosInstance} AxiosInstance */

import { SweetPath } from 'sweet-path';

/**
 * @typedef {import('./search-documents-action-body').SearchDocumentsActionBody} SearchDocumentsActionBody
 */

/**
 * @typedef {import('./search-documents-action-response').SearchDocumentsActionResponse} SearchDocumentsActionResponse
 */

/**
 * The path of the SearchDocumentsAction action.
 */
export const searchDocumentsActionPath = new SweetPath('/api/search/search/documents', { path: '{param}' });

/**
 * Creates a contextualized SearchDocumentsAction action.
 *
 * @param {AxiosInstance} axios
 */
export default function createSearchDocumentsAction(axios) {
  /**
   * The searchDocumentsAction action.
   *
   * @param { { headers: Object<string,string>,parameters: Object<string,string|number|boolean>,body: SearchDocumentsActionBody } }
   *
   * @returns {Promise<SearchDocumentsActionResponse>}
   */
  function searchDocumentsAction({ headers = {}, parameters = {}, body } = {}) {
    const path = searchDocumentsActionPath.insert(parameters);

    return axios.post(path, body, { headers });
  }

  return searchDocumentsAction;
}
